module.exports = __webpack_public_path__ + "static/media/picture-(195).8115c0c2.JPG";